export const PAYMENT_METHOD = {
	WIRE_TRANSFER: 1,
	DEBIT_CREDIT_CARD: 2,
	POSTPONED: 3,
}
